import React from 'react';
import styled from 'styled-components';
import css from '../utils/cssVariables';

const Footer = () => {
  return (
    <StyledF className="App-footer">
      <a href="/">
      </a>
      <LinkWrapper>
        <a href="https://twitter.com/LandofBlossoms/">Twitter</a>
        <a href="https://www.instagram.com/land_of_blossoms/">Instagram</a>
      </LinkWrapper>
    </StyledF>
  )
}

const StyledF = styled.footer`
  text-align: left;
  position: relative;
  padding: 3rem 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid #F4F4F5;
  margin: 10rem ${css.paddingLarge} 3rem;

  ${css.mobile} {
    padding: ${css.paddingSmall};
    margin: 0;
  }

  & img {
    display: inline-block;
    height: 1rem;
  }
`

const LinkWrapper = styled.div`
  display: inline-block;
  text-align: right;

  font-size: .6875rem;
  line-height: 1;

  ${css.mobile} {
    display: 100%;
  }

  & > a {
    color: #4F5874;
  }
  
  & > a:nth-of-type(2) {
    margin: 0 3rem;
  } 
`

export default Footer;